import api from "./api";

// 页面内容查询
export const postCPCC = params => {
  return api('post', `/v1/management/channel-page-content-configuration/`, params);
};

// 页面内容新增
export const addCPCC = params => {
  return api('post', `/v1/management/channel-page-content-configuration/add`, params);
};

// 页面内容修改
export const updateCPCC = params => {
  return api('post', `/v1/management/channel-page-content-configuration/update`, params);
};

